// React Router
import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// Components
import NavbarMain from "./components/Navigation-Bar";
import Footer from "./components/Footer";
import CookieConsent from "./components/CookieConsent";

// Pages
import HomePage from "./Page/Home-page";
import NotFoundPage from "./Page/NotFoundPage";
import Articles from "./Page/Articles";
import Contact from "./Page/Contact";
import Event from "./Page/Event";
import ServicesPage from "./Page/Services";
import SpecialOpsPage from "./Page/SpecialOpsPage";
import Team from "./Page/Team";

// Legal Pages
import PrivacyPolicy from "./Page/Legal/PrivacyPolicy";
import CookiePolicy from "./Page/Legal/CookiePolicy";
import Terms from "./Page/Legal/Terms";
import Disclaimer from "./Page/Legal/Disclaimer";

// Archive Articles
import ArticleA1 from "./Page/Articles/a1";
import ArticleA2 from "./Page/Articles/a2";
import ArticleA3 from "./Page/Articles/a3";
import ArticleA4 from "./Page/Articles/a4";
import ArticleA5 from "./Page/Articles/a5";
import ArticleA6 from "./Page/Articles/a6";


// Router Configuration
const router = createBrowserRouter([
  // Home
  { path: "/", element: <Navigate to="/home" replace /> },
  { path: "/home", element: <HomePage /> },


  // Other Pages

  { path: "/*", element: <NotFoundPage /> },
  { path: "/articles", element: <Articles /> },
  { path: "/contact", element: <Contact /> },
  { path: "/events", element: <Event /> },
  { path: "/service", element: <ServicesPage /> },
  { path: "/special-ops", element: <SpecialOpsPage /> },
  { path: "/team", element: <Team /> },

  // Legal Pages
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/cookie-policy", element: <CookiePolicy /> },
  { path: "/terms", element: <Terms /> },
  { path: "/disclaimer", element: <Disclaimer /> },

  // Articles
  { path: "/articles/a1", element: <ArticleA1 /> },
  { path: "/articles/a2", element: <ArticleA2 /> },
  { path: "/articles/a3", element: <ArticleA3 /> },
  { path: "/articles/a4", element: <ArticleA4 /> },
  { path: "/articles/a5", element: <ArticleA5 /> },
  { path: "/articles/a6", element: <ArticleA6 /> },
]);


// Main App Component
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <NavbarMain />
        <RouterProvider router={router} />
      </header>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
